// tslint:disable
// This file is generated by buildArt script.
// Please don't edit it manually.
export var IdAssetBundleBuildings;
(function (IdAssetBundleBuildings) {
    IdAssetBundleBuildings["LambsLettuceIcnS"] = "LambsLettuceIcnS";
    IdAssetBundleBuildings["acre_2"] = "acre_2";
    IdAssetBundleBuildings["acre_3"] = "acre_3";
    IdAssetBundleBuildings["acre_4"] = "acre_4";
    IdAssetBundleBuildings["acre_5"] = "acre_5";
    IdAssetBundleBuildings["acre_6"] = "acre_6";
    IdAssetBundleBuildings["acre_7"] = "acre_7";
    IdAssetBundleBuildings["acre_8"] = "acre_8";
    IdAssetBundleBuildings["acre_seeds_barley_1"] = "acre_seeds_barley_1";
    IdAssetBundleBuildings["acre_seeds_barley_2"] = "acre_seeds_barley_2";
    IdAssetBundleBuildings["acre_seeds_barley_3"] = "acre_seeds_barley_3";
    IdAssetBundleBuildings["acre_seeds_cabbage_1"] = "acre_seeds_cabbage_1";
    IdAssetBundleBuildings["acre_seeds_cabbage_2"] = "acre_seeds_cabbage_2";
    IdAssetBundleBuildings["acre_seeds_cabbage_3"] = "acre_seeds_cabbage_3";
    IdAssetBundleBuildings["acre_seeds_daisies_1"] = "acre_seeds_daisies_1";
    IdAssetBundleBuildings["acre_seeds_daisies_2"] = "acre_seeds_daisies_2";
    IdAssetBundleBuildings["acre_seeds_daisies_3"] = "acre_seeds_daisies_3";
    IdAssetBundleBuildings["acre_seeds_dandelion_1"] = "acre_seeds_dandelion_1";
    IdAssetBundleBuildings["acre_seeds_dandelion_2"] = "acre_seeds_dandelion_2";
    IdAssetBundleBuildings["acre_seeds_dandelion_3"] = "acre_seeds_dandelion_3";
    IdAssetBundleBuildings["acre_seeds_ginger_1"] = "acre_seeds_ginger_1";
    IdAssetBundleBuildings["acre_seeds_ginger_2"] = "acre_seeds_ginger_2";
    IdAssetBundleBuildings["acre_seeds_ginger_3"] = "acre_seeds_ginger_3";
    IdAssetBundleBuildings["acre_seeds_goldflowers_1"] = "acre_seeds_goldflowers_1";
    IdAssetBundleBuildings["acre_seeds_goldflowers_2"] = "acre_seeds_goldflowers_2";
    IdAssetBundleBuildings["acre_seeds_goldflowers_3"] = "acre_seeds_goldflowers_3";
    IdAssetBundleBuildings["acre_seeds_lambsLettuce_1"] = "acre_seeds_lambsLettuce_1";
    IdAssetBundleBuildings["acre_seeds_lambsLettuce_2"] = "acre_seeds_lambsLettuce_2";
    IdAssetBundleBuildings["acre_seeds_lambsLettuce_3"] = "acre_seeds_lambsLettuce_3";
    IdAssetBundleBuildings["acre_seeds_pumpkin_1"] = "acre_seeds_pumpkin_1";
    IdAssetBundleBuildings["acre_seeds_pumpkin_2"] = "acre_seeds_pumpkin_2";
    IdAssetBundleBuildings["acre_seeds_pumpkin_3"] = "acre_seeds_pumpkin_3";
    IdAssetBundleBuildings["acre_seeds_roses_1"] = "acre_seeds_roses_1";
    IdAssetBundleBuildings["acre_seeds_roses_2"] = "acre_seeds_roses_2";
    IdAssetBundleBuildings["acre_seeds_roses_3"] = "acre_seeds_roses_3";
    IdAssetBundleBuildings["acre_seeds_rutabaga_1"] = "acre_seeds_rutabaga_1";
    IdAssetBundleBuildings["acre_seeds_rutabaga_2"] = "acre_seeds_rutabaga_2";
    IdAssetBundleBuildings["acre_seeds_rutabaga_3"] = "acre_seeds_rutabaga_3";
    IdAssetBundleBuildings["acre_seeds_wheat_1"] = "acre_seeds_wheat_1";
    IdAssetBundleBuildings["acre_seeds_wheat_2"] = "acre_seeds_wheat_2";
    IdAssetBundleBuildings["acre_seeds_wheat_3"] = "acre_seeds_wheat_3";
    IdAssetBundleBuildings["acre_seeds_wildflowers_1"] = "acre_seeds_wildflowers_1";
    IdAssetBundleBuildings["acre_seeds_wildflowers_2"] = "acre_seeds_wildflowers_2";
    IdAssetBundleBuildings["acre_seeds_wildflowers_3"] = "acre_seeds_wildflowers_3";
    IdAssetBundleBuildings["acre_seeds_xpFlowers_1"] = "acre_seeds_xpFlowers_1";
    IdAssetBundleBuildings["acre_seeds_xpFlowers_2"] = "acre_seeds_xpFlowers_2";
    IdAssetBundleBuildings["acre_seeds_xpFlowers_3"] = "acre_seeds_xpFlowers_3";
    IdAssetBundleBuildings["almondOrchard_1"] = "almondOrchard_1";
    IdAssetBundleBuildings["almondOrchard_2"] = "almondOrchard_2";
    IdAssetBundleBuildings["almondOrchard_3"] = "almondOrchard_3";
    IdAssetBundleBuildings["almondOrchard_4"] = "almondOrchard_4";
    IdAssetBundleBuildings["almondOrchard_5"] = "almondOrchard_5";
    IdAssetBundleBuildings["almondOrchard_6"] = "almondOrchard_6";
    IdAssetBundleBuildings["almondOrchard_7"] = "almondOrchard_7";
    IdAssetBundleBuildings["almondOrchard_8"] = "almondOrchard_8";
    IdAssetBundleBuildings["almond_orchard_almond_1"] = "almond_orchard_almond_1";
    IdAssetBundleBuildings["almond_orchard_almond_2"] = "almond_orchard_almond_2";
    IdAssetBundleBuildings["almond_orchard_blossom_1"] = "almond_orchard_blossom_1";
    IdAssetBundleBuildings["amazonDragonStatue_1"] = "amazonDragonStatue_1";
    IdAssetBundleBuildings["andromedaObservatory_1"] = "andromedaObservatory_1";
    IdAssetBundleBuildings["andromedaObservatory_2"] = "andromedaObservatory_2";
    IdAssetBundleBuildings["andromedaObservatory_3"] = "andromedaObservatory_3";
    IdAssetBundleBuildings["andromedaObservatory_4"] = "andromedaObservatory_4";
    IdAssetBundleBuildings["andromedaObservatory_5"] = "andromedaObservatory_5";
    IdAssetBundleBuildings["andromedaObservatory_6"] = "andromedaObservatory_6";
    IdAssetBundleBuildings["andromedaObservatory_7"] = "andromedaObservatory_7";
    IdAssetBundleBuildings["animalChessboard_1"] = "animalChessboard_1";
    IdAssetBundleBuildings["animalChessboard_2"] = "animalChessboard_2";
    IdAssetBundleBuildings["animalChessboard_3"] = "animalChessboard_3";
    IdAssetBundleBuildings["animalSoccer_1"] = "animalSoccer_1";
    IdAssetBundleBuildings["animalSoccer_2"] = "animalSoccer_2";
    IdAssetBundleBuildings["animalSoccer_3"] = "animalSoccer_3";
    IdAssetBundleBuildings["animalSoccer_4"] = "animalSoccer_4";
    IdAssetBundleBuildings["animalSoccer_5"] = "animalSoccer_5";
    IdAssetBundleBuildings["animalSoccer_6"] = "animalSoccer_6";
    IdAssetBundleBuildings["animalSoccer_7"] = "animalSoccer_7";
    IdAssetBundleBuildings["animal_chicken"] = "animal_chicken";
    IdAssetBundleBuildings["animal_cow"] = "animal_cow";
    IdAssetBundleBuildings["animal_goat1"] = "animal_goat1";
    IdAssetBundleBuildings["animal_goat2"] = "animal_goat2";
    IdAssetBundleBuildings["animal_pig"] = "animal_pig";
    IdAssetBundleBuildings["appleOrchard_1"] = "appleOrchard_1";
    IdAssetBundleBuildings["appleOrchard_2"] = "appleOrchard_2";
    IdAssetBundleBuildings["appleOrchard_3"] = "appleOrchard_3";
    IdAssetBundleBuildings["appleOrchard_4"] = "appleOrchard_4";
    IdAssetBundleBuildings["appleOrchard_5"] = "appleOrchard_5";
    IdAssetBundleBuildings["appleOrchard_6"] = "appleOrchard_6";
    IdAssetBundleBuildings["appleOrchard_7"] = "appleOrchard_7";
    IdAssetBundleBuildings["appleOrchard_8"] = "appleOrchard_8";
    IdAssetBundleBuildings["apple_orchard_apples_1"] = "apple_orchard_apples_1";
    IdAssetBundleBuildings["apple_orchard_apples_3"] = "apple_orchard_apples_3";
    IdAssetBundleBuildings["apple_orchard_blossom_1"] = "apple_orchard_blossom_1";
    IdAssetBundleBuildings["asianArchway_1"] = "asianArchway_1";
    IdAssetBundleBuildings["barn_2"] = "barn_2";
    IdAssetBundleBuildings["barn_3"] = "barn_3";
    IdAssetBundleBuildings["barn_4"] = "barn_4";
    IdAssetBundleBuildings["barn_5"] = "barn_5";
    IdAssetBundleBuildings["barn_6"] = "barn_6";
    IdAssetBundleBuildings["barn_7"] = "barn_7";
    IdAssetBundleBuildings["barn_8"] = "barn_8";
    IdAssetBundleBuildings["beehive_1"] = "beehive_1";
    IdAssetBundleBuildings["beehive_2"] = "beehive_2";
    IdAssetBundleBuildings["beehive_3"] = "beehive_3";
    IdAssetBundleBuildings["beehive_4"] = "beehive_4";
    IdAssetBundleBuildings["beehive_active_1"] = "beehive_active_1";
    IdAssetBundleBuildings["beehive_active_2"] = "beehive_active_2";
    IdAssetBundleBuildings["beehive_active_3"] = "beehive_active_3";
    IdAssetBundleBuildings["beehive_active_4"] = "beehive_active_4";
    IdAssetBundleBuildings["bigOrnamentalTree_1"] = "bigOrnamentalTree_1";
    IdAssetBundleBuildings["birdbath_1"] = "birdbath_1";
    IdAssetBundleBuildings["birdbath_2"] = "birdbath_2";
    IdAssetBundleBuildings["birdbath_3"] = "birdbath_3";
    IdAssetBundleBuildings["bloom_cherry1"] = "bloom_cherry1";
    IdAssetBundleBuildings["bloom_cherry2"] = "bloom_cherry2";
    IdAssetBundleBuildings["butterflyFeeder_1"] = "butterflyFeeder_1";
    IdAssetBundleBuildings["butterflyStatue_1"] = "butterflyStatue_1";
    IdAssetBundleBuildings["camp1_1"] = "camp1_1";
    IdAssetBundleBuildings["camp2_1"] = "camp2_1";
    IdAssetBundleBuildings["camp3_1"] = "camp3_1";
    IdAssetBundleBuildings["camp4_1"] = "camp4_1";
    IdAssetBundleBuildings["camp5_1"] = "camp5_1";
    IdAssetBundleBuildings["camp6_1"] = "camp6_1";
    IdAssetBundleBuildings["camp_1"] = "camp_1";
    IdAssetBundleBuildings["candyChickenCoop_1"] = "candyChickenCoop_1";
    IdAssetBundleBuildings["candyChickenCoop_1_fence"] = "candyChickenCoop_1_fence";
    IdAssetBundleBuildings["candyChickenCoop_2"] = "candyChickenCoop_2";
    IdAssetBundleBuildings["candyChickenCoop_2_fence"] = "candyChickenCoop_2_fence";
    IdAssetBundleBuildings["candyChickenCoop_3"] = "candyChickenCoop_3";
    IdAssetBundleBuildings["candyChickenCoop_3_fence"] = "candyChickenCoop_3_fence";
    IdAssetBundleBuildings["candyChickenCoop_4"] = "candyChickenCoop_4";
    IdAssetBundleBuildings["candyChickenCoop_4_fence"] = "candyChickenCoop_4_fence";
    IdAssetBundleBuildings["candyChickenCoop_5"] = "candyChickenCoop_5";
    IdAssetBundleBuildings["candyChickenCoop_5_fence"] = "candyChickenCoop_5_fence";
    IdAssetBundleBuildings["candyChickenCoop_6"] = "candyChickenCoop_6";
    IdAssetBundleBuildings["candyChickenCoop_6_fence"] = "candyChickenCoop_6_fence";
    IdAssetBundleBuildings["candyChickenCoop_7"] = "candyChickenCoop_7";
    IdAssetBundleBuildings["candyChickenCoop_7_fence"] = "candyChickenCoop_7_fence";
    IdAssetBundleBuildings["candyChickenCoop_8"] = "candyChickenCoop_8";
    IdAssetBundleBuildings["candyChickenCoop_8_fence"] = "candyChickenCoop_8_fence";
    IdAssetBundleBuildings["candyCowBarn_1"] = "candyCowBarn_1";
    IdAssetBundleBuildings["candyCowBarn_1_fence"] = "candyCowBarn_1_fence";
    IdAssetBundleBuildings["candyCowBarn_2"] = "candyCowBarn_2";
    IdAssetBundleBuildings["candyCowBarn_2_fence"] = "candyCowBarn_2_fence";
    IdAssetBundleBuildings["candyCowBarn_3"] = "candyCowBarn_3";
    IdAssetBundleBuildings["candyCowBarn_3_fence"] = "candyCowBarn_3_fence";
    IdAssetBundleBuildings["candyCowBarn_4"] = "candyCowBarn_4";
    IdAssetBundleBuildings["candyCowBarn_4_fence"] = "candyCowBarn_4_fence";
    IdAssetBundleBuildings["candyCowBarn_5"] = "candyCowBarn_5";
    IdAssetBundleBuildings["candyCowBarn_5_fence"] = "candyCowBarn_5_fence";
    IdAssetBundleBuildings["candyCowBarn_6"] = "candyCowBarn_6";
    IdAssetBundleBuildings["candyCowBarn_6_fence"] = "candyCowBarn_6_fence";
    IdAssetBundleBuildings["candyCowBarn_7"] = "candyCowBarn_7";
    IdAssetBundleBuildings["candyCowBarn_7_fence"] = "candyCowBarn_7_fence";
    IdAssetBundleBuildings["candyHouse_1"] = "candyHouse_1";
    IdAssetBundleBuildings["candyHouse_2"] = "candyHouse_2";
    IdAssetBundleBuildings["candyHouse_3"] = "candyHouse_3";
    IdAssetBundleBuildings["candyHouse_4"] = "candyHouse_4";
    IdAssetBundleBuildings["candyHouse_5"] = "candyHouse_5";
    IdAssetBundleBuildings["candyHouse_6"] = "candyHouse_6";
    IdAssetBundleBuildings["celebration_3x3"] = "celebration_3x3";
    IdAssetBundleBuildings["celebration_3x6"] = "celebration_3x6";
    IdAssetBundleBuildings["celebration_6x9"] = "celebration_6x9";
    IdAssetBundleBuildings["celebration_9x9"] = "celebration_9x9";
    IdAssetBundleBuildings["cherryOrchard_1"] = "cherryOrchard_1";
    IdAssetBundleBuildings["cherryOrchard_2"] = "cherryOrchard_2";
    IdAssetBundleBuildings["cherryOrchard_3"] = "cherryOrchard_3";
    IdAssetBundleBuildings["cherryOrchard_4"] = "cherryOrchard_4";
    IdAssetBundleBuildings["cherryOrchard_5"] = "cherryOrchard_5";
    IdAssetBundleBuildings["cherryOrchard_6"] = "cherryOrchard_6";
    IdAssetBundleBuildings["cherryOrchard_7"] = "cherryOrchard_7";
    IdAssetBundleBuildings["cherryOrchard_8"] = "cherryOrchard_8";
    IdAssetBundleBuildings["chickenBush_1"] = "chickenBush_1";
    IdAssetBundleBuildings["chickenCoop_2"] = "chickenCoop_2";
    IdAssetBundleBuildings["chickenCoop_2_fence"] = "chickenCoop_2_fence";
    IdAssetBundleBuildings["chickenCoop_3"] = "chickenCoop_3";
    IdAssetBundleBuildings["chickenCoop_3_fence"] = "chickenCoop_3_fence";
    IdAssetBundleBuildings["chickenCoop_4"] = "chickenCoop_4";
    IdAssetBundleBuildings["chickenCoop_4_fence"] = "chickenCoop_4_fence";
    IdAssetBundleBuildings["chickenCoop_5"] = "chickenCoop_5";
    IdAssetBundleBuildings["chickenCoop_5_fence"] = "chickenCoop_5_fence";
    IdAssetBundleBuildings["chickenCoop_6"] = "chickenCoop_6";
    IdAssetBundleBuildings["chickenCoop_6_fence"] = "chickenCoop_6_fence";
    IdAssetBundleBuildings["chickenCoop_7"] = "chickenCoop_7";
    IdAssetBundleBuildings["chickenCoop_7_fence"] = "chickenCoop_7_fence";
    IdAssetBundleBuildings["chickenCoop_8"] = "chickenCoop_8";
    IdAssetBundleBuildings["chickenCoop_8_fence"] = "chickenCoop_8_fence";
    IdAssetBundleBuildings["chickenCup_1"] = "chickenCup_1";
    IdAssetBundleBuildings["childOfTheWaves_1"] = "childOfTheWaves_1";
    IdAssetBundleBuildings["childOfTheWaves_2"] = "childOfTheWaves_2";
    IdAssetBundleBuildings["childOfTheWaves_3"] = "childOfTheWaves_3";
    IdAssetBundleBuildings["childOfTheWaves_4"] = "childOfTheWaves_4";
    IdAssetBundleBuildings["childOfTheWaves_5"] = "childOfTheWaves_5";
    IdAssetBundleBuildings["childOfTheWaves_6"] = "childOfTheWaves_6";
    IdAssetBundleBuildings["childOfTheWaves_7"] = "childOfTheWaves_7";
    IdAssetBundleBuildings["christmasTree2019_1"] = "christmasTree2019_1";
    IdAssetBundleBuildings["christmasTree2019_10"] = "christmasTree2019_10";
    IdAssetBundleBuildings["christmasTree2019_2"] = "christmasTree2019_2";
    IdAssetBundleBuildings["christmasTree2019_3"] = "christmasTree2019_3";
    IdAssetBundleBuildings["christmasTree2019_4"] = "christmasTree2019_4";
    IdAssetBundleBuildings["christmasTree2019_5"] = "christmasTree2019_5";
    IdAssetBundleBuildings["christmasTree2019_6"] = "christmasTree2019_6";
    IdAssetBundleBuildings["christmasTree2019_7"] = "christmasTree2019_7";
    IdAssetBundleBuildings["christmasTree2019_8"] = "christmasTree2019_8";
    IdAssetBundleBuildings["christmasTree2019_9"] = "christmasTree2019_9";
    IdAssetBundleBuildings["clothesline_1"] = "clothesline_1";
    IdAssetBundleBuildings["composter_1"] = "composter_1";
    IdAssetBundleBuildings["composter_2"] = "composter_2";
    IdAssetBundleBuildings["composter_3"] = "composter_3";
    IdAssetBundleBuildings["composter_4"] = "composter_4";
    IdAssetBundleBuildings["composter_5"] = "composter_5";
    IdAssetBundleBuildings["composter_6"] = "composter_6";
    IdAssetBundleBuildings["composter_foliage_1"] = "composter_foliage_1";
    IdAssetBundleBuildings["composter_foliage_2"] = "composter_foliage_2";
    IdAssetBundleBuildings["composter_foliage_3"] = "composter_foliage_3";
    IdAssetBundleBuildings["composter_foliage_4"] = "composter_foliage_4";
    IdAssetBundleBuildings["composter_foliage_5"] = "composter_foliage_5";
    IdAssetBundleBuildings["composter_foliage_6"] = "composter_foliage_6";
    IdAssetBundleBuildings["cowBarn_1"] = "cowBarn_1";
    IdAssetBundleBuildings["cowBarn_1_fence"] = "cowBarn_1_fence";
    IdAssetBundleBuildings["cowBarn_2"] = "cowBarn_2";
    IdAssetBundleBuildings["cowBarn_2_fence"] = "cowBarn_2_fence";
    IdAssetBundleBuildings["cowBarn_3"] = "cowBarn_3";
    IdAssetBundleBuildings["cowBarn_3_fence"] = "cowBarn_3_fence";
    IdAssetBundleBuildings["cowBarn_4"] = "cowBarn_4";
    IdAssetBundleBuildings["cowBarn_4_fence"] = "cowBarn_4_fence";
    IdAssetBundleBuildings["cowBarn_5"] = "cowBarn_5";
    IdAssetBundleBuildings["cowBarn_5_fence"] = "cowBarn_5_fence";
    IdAssetBundleBuildings["cowBarn_6"] = "cowBarn_6";
    IdAssetBundleBuildings["cowBarn_6_fence"] = "cowBarn_6_fence";
    IdAssetBundleBuildings["cowBarn_7"] = "cowBarn_7";
    IdAssetBundleBuildings["cowBarn_7_fence"] = "cowBarn_7_fence";
    IdAssetBundleBuildings["cowBarn_8"] = "cowBarn_8";
    IdAssetBundleBuildings["cowBarn_8_fence"] = "cowBarn_8_fence";
    IdAssetBundleBuildings["cowCup_1"] = "cowCup_1";
    IdAssetBundleBuildings["cozyTeaGarden_1"] = "cozyTeaGarden_1";
    IdAssetBundleBuildings["cozyTeaGarden_2"] = "cozyTeaGarden_2";
    IdAssetBundleBuildings["cozyTeaGarden_3"] = "cozyTeaGarden_3";
    IdAssetBundleBuildings["cozyTeaGarden_4"] = "cozyTeaGarden_4";
    IdAssetBundleBuildings["cozyTeaGarden_5"] = "cozyTeaGarden_5";
    IdAssetBundleBuildings["cozyTeaGarden_6"] = "cozyTeaGarden_6";
    IdAssetBundleBuildings["crater_1"] = "crater_1";
    IdAssetBundleBuildings["cropCircles_1"] = "cropCircles_1";
    IdAssetBundleBuildings["deadTree_1"] = "deadTree_1";
    IdAssetBundleBuildings["dragonDance1_1"] = "dragonDance1_1";
    IdAssetBundleBuildings["dragonDance2_1"] = "dragonDance2_1";
    IdAssetBundleBuildings["dragonDance3_1"] = "dragonDance3_1";
    IdAssetBundleBuildings["dragonDance4_1"] = "dragonDance4_1";
    IdAssetBundleBuildings["dragonDance5_1"] = "dragonDance5_1";
    IdAssetBundleBuildings["dragonDance6_1"] = "dragonDance6_1";
    IdAssetBundleBuildings["dragonDance7_1"] = "dragonDance7_1";
    IdAssetBundleBuildings["duckCoop_1"] = "duckCoop_1";
    IdAssetBundleBuildings["duckCoop_1_fence"] = "duckCoop_1_fence";
    IdAssetBundleBuildings["duckCoop_2"] = "duckCoop_2";
    IdAssetBundleBuildings["duckCoop_22"] = "duckCoop_22";
    IdAssetBundleBuildings["duckCoop_2_fence"] = "duckCoop_2_fence";
    IdAssetBundleBuildings["duckCoop_3"] = "duckCoop_3";
    IdAssetBundleBuildings["duckCoop_3_fence"] = "duckCoop_3_fence";
    IdAssetBundleBuildings["duckCoop_4"] = "duckCoop_4";
    IdAssetBundleBuildings["duckCoop_4_fence"] = "duckCoop_4_fence";
    IdAssetBundleBuildings["duckCoop_5"] = "duckCoop_5";
    IdAssetBundleBuildings["duckCoop_5_fence"] = "duckCoop_5_fence";
    IdAssetBundleBuildings["duckCoop_6"] = "duckCoop_6";
    IdAssetBundleBuildings["duckCoop_6_fence"] = "duckCoop_6_fence";
    IdAssetBundleBuildings["duckCoop_7"] = "duckCoop_7";
    IdAssetBundleBuildings["duckCoop_7_fence"] = "duckCoop_7_fence";
    IdAssetBundleBuildings["duckCoop_8"] = "duckCoop_8";
    IdAssetBundleBuildings["duckCoop_8_fence"] = "duckCoop_8_fence";
    IdAssetBundleBuildings["duckCoop_9"] = "duckCoop_9";
    IdAssetBundleBuildings["duckCoop_9_fence"] = "duckCoop_9_fence";
    IdAssetBundleBuildings["duckCoop_animal_duck1"] = "duckCoop_animal_duck1";
    IdAssetBundleBuildings["duckCoop_animal_duck2"] = "duckCoop_animal_duck2";
    IdAssetBundleBuildings["duckCoop_animal_duck3"] = "duckCoop_animal_duck3";
    IdAssetBundleBuildings["duckPond_1"] = "duckPond_1";
    IdAssetBundleBuildings["easterBunnyInc_1"] = "easterBunnyInc_1";
    IdAssetBundleBuildings["easterBunnysHome_1"] = "easterBunnysHome_1";
    IdAssetBundleBuildings["easterBunnysHome_2"] = "easterBunnysHome_2";
    IdAssetBundleBuildings["easterBunnysHome_3"] = "easterBunnysHome_3";
    IdAssetBundleBuildings["easterBunnysHome_4"] = "easterBunnysHome_4";
    IdAssetBundleBuildings["easterBunnysHome_5"] = "easterBunnysHome_5";
    IdAssetBundleBuildings["easterBunnysHome_6"] = "easterBunnysHome_6";
    IdAssetBundleBuildings["easterBunnysHome_7"] = "easterBunnysHome_7";
    IdAssetBundleBuildings["elvesTable_1"] = "elvesTable_1";
    IdAssetBundleBuildings["enchantedTree_1"] = "enchantedTree_1";
    IdAssetBundleBuildings["extravagantElderBush_1"] = "extravagantElderBush_1";
    IdAssetBundleBuildings["fairytaleTower1_1"] = "fairytaleTower1_1";
    IdAssetBundleBuildings["fairytaleTower2_1"] = "fairytaleTower2_1";
    IdAssetBundleBuildings["fairytaleTower3_1"] = "fairytaleTower3_1";
    IdAssetBundleBuildings["fairytaleTower4_1"] = "fairytaleTower4_1";
    IdAssetBundleBuildings["fairytaleTower5_1"] = "fairytaleTower5_1";
    IdAssetBundleBuildings["fairytaleTower6_1"] = "fairytaleTower6_1";
    IdAssetBundleBuildings["fancyHouse_1"] = "fancyHouse_1";
    IdAssetBundleBuildings["fancyHouse_2"] = "fancyHouse_2";
    IdAssetBundleBuildings["fancyHouse_3"] = "fancyHouse_3";
    IdAssetBundleBuildings["fancyHouse_4"] = "fancyHouse_4";
    IdAssetBundleBuildings["fancyHouse_5"] = "fancyHouse_5";
    IdAssetBundleBuildings["fancyHouse_6"] = "fancyHouse_6";
    IdAssetBundleBuildings["farmHouse_2"] = "farmHouse_2";
    IdAssetBundleBuildings["farmHouse_3"] = "farmHouse_3";
    IdAssetBundleBuildings["farmHouse_4"] = "farmHouse_4";
    IdAssetBundleBuildings["farmHouse_5"] = "farmHouse_5";
    IdAssetBundleBuildings["farmHouse_6"] = "farmHouse_6";
    IdAssetBundleBuildings["farmHouse_7"] = "farmHouse_7";
    IdAssetBundleBuildings["farmHouse_8"] = "farmHouse_8";
    IdAssetBundleBuildings["farmHouse_9"] = "farmHouse_9";
    IdAssetBundleBuildings["fertileAcre_1"] = "fertileAcre_1";
    IdAssetBundleBuildings["fertileAcre_2"] = "fertileAcre_2";
    IdAssetBundleBuildings["fertileAcre_3"] = "fertileAcre_3";
    IdAssetBundleBuildings["fertileAcre_4"] = "fertileAcre_4";
    IdAssetBundleBuildings["fertileAcre_5"] = "fertileAcre_5";
    IdAssetBundleBuildings["fertileAcre_6"] = "fertileAcre_6";
    IdAssetBundleBuildings["fertileAcre_7"] = "fertileAcre_7";
    IdAssetBundleBuildings["fertileAcre_8"] = "fertileAcre_8";
    IdAssetBundleBuildings["fertileAlmondOrchard_1"] = "fertileAlmondOrchard_1";
    IdAssetBundleBuildings["fertileAlmondOrchard_2"] = "fertileAlmondOrchard_2";
    IdAssetBundleBuildings["fertileAlmondOrchard_3"] = "fertileAlmondOrchard_3";
    IdAssetBundleBuildings["fertileAlmondOrchard_4"] = "fertileAlmondOrchard_4";
    IdAssetBundleBuildings["fertileAlmondOrchard_5"] = "fertileAlmondOrchard_5";
    IdAssetBundleBuildings["fertileAlmondOrchard_6"] = "fertileAlmondOrchard_6";
    IdAssetBundleBuildings["fertileAlmondOrchard_7"] = "fertileAlmondOrchard_7";
    IdAssetBundleBuildings["fertileAlmondOrchard_8"] = "fertileAlmondOrchard_8";
    IdAssetBundleBuildings["fertileAppleOrchard_1"] = "fertileAppleOrchard_1";
    IdAssetBundleBuildings["fertileAppleOrchard_2"] = "fertileAppleOrchard_2";
    IdAssetBundleBuildings["fertileAppleOrchard_3"] = "fertileAppleOrchard_3";
    IdAssetBundleBuildings["fertileAppleOrchard_4"] = "fertileAppleOrchard_4";
    IdAssetBundleBuildings["fertileAppleOrchard_5"] = "fertileAppleOrchard_5";
    IdAssetBundleBuildings["fertileAppleOrchard_6"] = "fertileAppleOrchard_6";
    IdAssetBundleBuildings["fertileAppleOrchard_7"] = "fertileAppleOrchard_7";
    IdAssetBundleBuildings["fertileAppleOrchard_8"] = "fertileAppleOrchard_8";
    IdAssetBundleBuildings["fertileCherryOrchard_1"] = "fertileCherryOrchard_1";
    IdAssetBundleBuildings["fertileCherryOrchard_2"] = "fertileCherryOrchard_2";
    IdAssetBundleBuildings["fertileCherryOrchard_3"] = "fertileCherryOrchard_3";
    IdAssetBundleBuildings["fertileCherryOrchard_4"] = "fertileCherryOrchard_4";
    IdAssetBundleBuildings["fertileCherryOrchard_5"] = "fertileCherryOrchard_5";
    IdAssetBundleBuildings["fertileCherryOrchard_6"] = "fertileCherryOrchard_6";
    IdAssetBundleBuildings["fertileCherryOrchard_7"] = "fertileCherryOrchard_7";
    IdAssetBundleBuildings["fertileCherryOrchard_8"] = "fertileCherryOrchard_8";
    IdAssetBundleBuildings["fertilePeachOrchard_1"] = "fertilePeachOrchard_1";
    IdAssetBundleBuildings["fertilePeachOrchard_2"] = "fertilePeachOrchard_2";
    IdAssetBundleBuildings["fertilePeachOrchard_3"] = "fertilePeachOrchard_3";
    IdAssetBundleBuildings["fertilePeachOrchard_4"] = "fertilePeachOrchard_4";
    IdAssetBundleBuildings["fertilePeachOrchard_5"] = "fertilePeachOrchard_5";
    IdAssetBundleBuildings["fertilePeachOrchard_6"] = "fertilePeachOrchard_6";
    IdAssetBundleBuildings["fertilePeachOrchard_7"] = "fertilePeachOrchard_7";
    IdAssetBundleBuildings["fertilePeachOrchard_8"] = "fertilePeachOrchard_8";
    IdAssetBundleBuildings["flowerbed_1"] = "flowerbed_1";
    IdAssetBundleBuildings["foodTruck_1"] = "foodTruck_1";
    IdAssetBundleBuildings["foodTruck_2"] = "foodTruck_2";
    IdAssetBundleBuildings["foodTruck_3"] = "foodTruck_3";
    IdAssetBundleBuildings["foodTruck_4"] = "foodTruck_4";
    IdAssetBundleBuildings["foodTruck_5"] = "foodTruck_5";
    IdAssetBundleBuildings["foodTruck_6"] = "foodTruck_6";
    IdAssetBundleBuildings["foodTruck_7"] = "foodTruck_7";
    IdAssetBundleBuildings["footballoons_1"] = "footballoons_1";
    IdAssetBundleBuildings["freeRangeAlmondOrchard_1"] = "freeRangeAlmondOrchard_1";
    IdAssetBundleBuildings["freeRangeAppleOrchard_1"] = "freeRangeAppleOrchard_1";
    IdAssetBundleBuildings["freeRangeCherryOrchard_1"] = "freeRangeCherryOrchard_1";
    IdAssetBundleBuildings["freeRangeChickenCoop_1"] = "freeRangeChickenCoop_1";
    IdAssetBundleBuildings["freeRangeCowBarn_1"] = "freeRangeCowBarn_1";
    IdAssetBundleBuildings["freeRangeDuckCoop_1"] = "freeRangeDuckCoop_1";
    IdAssetBundleBuildings["freeRangeGoatStable_1"] = "freeRangeGoatStable_1";
    IdAssetBundleBuildings["freeRangePigPen_1"] = "freeRangePigPen_1";
    IdAssetBundleBuildings["frogPrinceWell_1"] = "frogPrinceWell_1";
    IdAssetBundleBuildings["fruits_cherry1"] = "fruits_cherry1";
    IdAssetBundleBuildings["fruits_cherry2"] = "fruits_cherry2";
    IdAssetBundleBuildings["fruits_cherry3"] = "fruits_cherry3";
    IdAssetBundleBuildings["galacticGarden_1"] = "galacticGarden_1";
    IdAssetBundleBuildings["gingerBreadHouse_1"] = "gingerBreadHouse_1";
    IdAssetBundleBuildings["gnomeBath_1"] = "gnomeBath_1";
    IdAssetBundleBuildings["gnomeDate_1"] = "gnomeDate_1";
    IdAssetBundleBuildings["gnomeFishing_1"] = "gnomeFishing_1";
    IdAssetBundleBuildings["gnomeFlowers_1"] = "gnomeFlowers_1";
    IdAssetBundleBuildings["gnomeHome_1"] = "gnomeHome_1";
    IdAssetBundleBuildings["gnomeHouse_1"] = "gnomeHouse_1";
    IdAssetBundleBuildings["gnomeHouse_2"] = "gnomeHouse_2";
    IdAssetBundleBuildings["gnomeHouse_3"] = "gnomeHouse_3";
    IdAssetBundleBuildings["gnomeHouse_4"] = "gnomeHouse_4";
    IdAssetBundleBuildings["gnomeHouse_5"] = "gnomeHouse_5 ";
    IdAssetBundleBuildings["gnomePinwheels_1"] = "gnomePinwheels_1";
    IdAssetBundleBuildings["goatStable_1"] = "goatStable_1";
    IdAssetBundleBuildings["goatStable_1_fence"] = "goatStable_1_fence";
    IdAssetBundleBuildings["goatStable_2"] = "goatStable_2";
    IdAssetBundleBuildings["goatStable_2_fence"] = "goatStable_2_fence";
    IdAssetBundleBuildings["goatStable_3"] = "goatStable_3";
    IdAssetBundleBuildings["goatStable_3_fence"] = "goatStable_3_fence";
    IdAssetBundleBuildings["goatStable_4"] = "goatStable_4";
    IdAssetBundleBuildings["goatStable_4_fence"] = "goatStable_4_fence";
    IdAssetBundleBuildings["goatStable_5"] = "goatStable_5";
    IdAssetBundleBuildings["goatStable_5_fence"] = "goatStable_5_fence";
    IdAssetBundleBuildings["goatStable_6"] = "goatStable_6";
    IdAssetBundleBuildings["goatStable_6_fence"] = "goatStable_6_fence";
    IdAssetBundleBuildings["goatStable_7"] = "goatStable_7";
    IdAssetBundleBuildings["goatStable_7_fence"] = "goatStable_7_fence";
    IdAssetBundleBuildings["goatStable_8"] = "goatStable_8";
    IdAssetBundleBuildings["goatStable_8_fence"] = "goatStable_8_fence ";
    IdAssetBundleBuildings["goatStable_9"] = "goatStable_9 ";
    IdAssetBundleBuildings["goatStable_9_fence"] = "goatStable_9_fence";
    IdAssetBundleBuildings["goldenSoccerBall_1"] = "goldenSoccerBall_1";
    IdAssetBundleBuildings["gumballMachine_1"] = "gumballMachine_1";
    IdAssetBundleBuildings["hauntedCastle_1"] = "hauntedCastle_1";
    IdAssetBundleBuildings["hauntedHouse_1"] = "hauntedHouse_1";
    IdAssetBundleBuildings["hauntedHouse_2"] = "hauntedHouse_2";
    IdAssetBundleBuildings["hauntedHouse_3"] = "hauntedHouse_3";
    IdAssetBundleBuildings["hauntedHouse_4"] = "hauntedHouse_4";
    IdAssetBundleBuildings["hauntedHouse_5"] = "hauntedHouse_5";
    IdAssetBundleBuildings["hauntedHouse_6"] = "hauntedHouse_6";
    IdAssetBundleBuildings["hauntedHouse_7"] = "hauntedHouse_7";
    IdAssetBundleBuildings["hawaiianBeach_1"] = "hawaiianBeach_1";
    IdAssetBundleBuildings["hawaiianFountain_1"] = "hawaiianFountain_1";
    IdAssetBundleBuildings["hayBale_1"] = "hayBale_1";
    IdAssetBundleBuildings["heartTrees_1"] = "heartTrees_1";
    IdAssetBundleBuildings["hotSprings_1"] = "hotSprings_1";
    IdAssetBundleBuildings["hotSprings_2"] = "hotSprings_2";
    IdAssetBundleBuildings["hotSprings_3"] = "hotSprings_3";
    IdAssetBundleBuildings["jackOLantern_1"] = "jackOLantern_1";
    IdAssetBundleBuildings["koiPond_1"] = "koiPond_1";
    IdAssetBundleBuildings["lavaSpring_1"] = "lavaSpring_1";
    IdAssetBundleBuildings["logBridge_1"] = "logBridge_1";
    IdAssetBundleBuildings["magicalWinterTree_1"] = "magicalWinterTree_1";
    IdAssetBundleBuildings["manufactory_1"] = "manufactory_1";
    IdAssetBundleBuildings["manufactory_2"] = "manufactory_2";
    IdAssetBundleBuildings["manufactory_3"] = "manufactory_3";
    IdAssetBundleBuildings["manufactory_4"] = "manufactory_4";
    IdAssetBundleBuildings["manufactory_5"] = "manufactory_5";
    IdAssetBundleBuildings["manufactory_6"] = "manufactory_6";
    IdAssetBundleBuildings["manufactory_7"] = "manufactory_7";
    IdAssetBundleBuildings["manufactory_8"] = "manufactory_8";
    IdAssetBundleBuildings["manufactory_active1"] = "manufactory_active1";
    IdAssetBundleBuildings["manufactory_active2"] = "manufactory_active2";
    IdAssetBundleBuildings["manufactory_active3"] = "manufactory_active3";
    IdAssetBundleBuildings["manufactory_active4"] = "manufactory_active4";
    IdAssetBundleBuildings["manufactory_active5"] = "manufactory_active5";
    IdAssetBundleBuildings["manufactory_active6"] = "manufactory_active6";
    IdAssetBundleBuildings["manufactory_active7"] = "manufactory_active7";
    IdAssetBundleBuildings["manufactory_active8"] = "manufactory_active8";
    IdAssetBundleBuildings["maypole_1"] = "maypole_1";
    IdAssetBundleBuildings["meadow_1"] = "meadow_1";
    IdAssetBundleBuildings["meadow_2"] = "meadow_2";
    IdAssetBundleBuildings["meadow_2_fence"] = "meadow_2_fence";
    IdAssetBundleBuildings["meadow_3"] = "meadow_3";
    IdAssetBundleBuildings["meadow_3_fence"] = "meadow_3_fence";
    IdAssetBundleBuildings["meadow_4"] = "meadow_4";
    IdAssetBundleBuildings["meadow_4_fence"] = "meadow_4_fence";
    IdAssetBundleBuildings["meadow_5"] = "meadow_5";
    IdAssetBundleBuildings["meadow_5_fence"] = "meadow_5_fence";
    IdAssetBundleBuildings["meadow_6"] = "meadow_6";
    IdAssetBundleBuildings["meadow_6_fence"] = "meadow_6_fence";
    IdAssetBundleBuildings["meadow_7"] = "meadow_7";
    IdAssetBundleBuildings["meadow_7_fence"] = "meadow_7_fence";
    IdAssetBundleBuildings["meadow_8"] = "meadow_8";
    IdAssetBundleBuildings["meadow_8_fence"] = "meadow_8_fence";
    IdAssetBundleBuildings["meadow_seeds_aloeVera_1"] = "meadow_seeds_aloeVera_1";
    IdAssetBundleBuildings["meadow_seeds_aloeVera_2"] = "meadow_seeds_aloeVera_2";
    IdAssetBundleBuildings["meadow_seeds_aloeVera_3"] = "meadow_seeds_aloeVera_3";
    IdAssetBundleBuildings["meadow_seeds_citrusFruits_1"] = "meadow_seeds_citrusFruits_1";
    IdAssetBundleBuildings["meadow_seeds_citrusFruits_2"] = "meadow_seeds_citrusFruits_2";
    IdAssetBundleBuildings["meadow_seeds_citrusFruits_3"] = "meadow_seeds_citrusFruits_3";
    IdAssetBundleBuildings["meadow_seeds_cocoa_1"] = "meadow_seeds_cocoa_1";
    IdAssetBundleBuildings["meadow_seeds_cocoa_2"] = "meadow_seeds_cocoa_2";
    IdAssetBundleBuildings["meadow_seeds_cocoa_3"] = "meadow_seeds_cocoa_3";
    IdAssetBundleBuildings["meadow_seeds_jasmine_1"] = "meadow_seeds_jasmine_1";
    IdAssetBundleBuildings["meadow_seeds_jasmine_2"] = "meadow_seeds_jasmine_2";
    IdAssetBundleBuildings["meadow_seeds_jasmine_3"] = "meadow_seeds_jasmine_3";
    IdAssetBundleBuildings["meadow_seeds_lavender_1"] = "meadow_seeds_lavender_1";
    IdAssetBundleBuildings["meadow_seeds_lavender_2"] = "meadow_seeds_lavender_2";
    IdAssetBundleBuildings["meadow_seeds_lavender_3"] = "meadow_seeds_lavender_3";
    IdAssetBundleBuildings["meadow_seeds_olives_1"] = "meadow_seeds_olives_1";
    IdAssetBundleBuildings["meadow_seeds_olives_2"] = "meadow_seeds_olives_2";
    IdAssetBundleBuildings["meadow_seeds_olives_3"] = "meadow_seeds_olives_3";
    IdAssetBundleBuildings["meadow_seeds_vanilla_1"] = "meadow_seeds_vanilla_1";
    IdAssetBundleBuildings["meadow_seeds_vanilla_2"] = "meadow_seeds_vanilla_2";
    IdAssetBundleBuildings["meadow_seeds_vanilla_3"] = "meadow_seeds_vanilla_3";
    IdAssetBundleBuildings["mysticStoneDragon_1"] = "mysticStoneDragon_1";
    IdAssetBundleBuildings["nordlandDuckCoop_1"] = "nordlandDuckCoop_1";
    IdAssetBundleBuildings["nordlandDuckCoop_1_fence"] = "nordlandDuckCoop_1_fence";
    IdAssetBundleBuildings["nordlandDuckCoop_2"] = "nordlandDuckCoop_2";
    IdAssetBundleBuildings["nordlandDuckCoop_2_fence"] = "nordlandDuckCoop_2_fence";
    IdAssetBundleBuildings["nordlandDuckCoop_3"] = "nordlandDuckCoop_3";
    IdAssetBundleBuildings["nordlandDuckCoop_3_fence"] = "nordlandDuckCoop_3_fence";
    IdAssetBundleBuildings["nordlandDuckCoop_4"] = "nordlandDuckCoop_4";
    IdAssetBundleBuildings["nordlandDuckCoop_4_fence"] = "nordlandDuckCoop_4_fence";
    IdAssetBundleBuildings["nordlandDuckCoop_5"] = "nordlandDuckCoop_5";
    IdAssetBundleBuildings["nordlandDuckCoop_5_fence"] = "nordlandDuckCoop_5_fence";
    IdAssetBundleBuildings["nordlandDuckCoop_6"] = "nordlandDuckCoop_6";
    IdAssetBundleBuildings["nordlandDuckCoop_6_fence"] = "nordlandDuckCoop_6_fence";
    IdAssetBundleBuildings["nordlandDuckCoop_7"] = "nordlandDuckCoop_7";
    IdAssetBundleBuildings["nordlandDuckCoop_7_fence"] = "nordlandDuckCoop_7_fence";
    IdAssetBundleBuildings["nordlandDuckCoop_8"] = "nordlandDuckCoop_8";
    IdAssetBundleBuildings["nordlandDuckCoop_8_fence"] = "nordlandDuckCoop_8_fence";
    IdAssetBundleBuildings["nordlandDuckCoop_9"] = "nordlandDuckCoop_9";
    IdAssetBundleBuildings["nordlandDuckCoop_9_fence"] = "nordlandDuckCoop_9_fence";
    IdAssetBundleBuildings["nordlandGoatStable_1"] = "nordlandGoatStable_1";
    IdAssetBundleBuildings["nordlandGoatStable_1_fence"] = "nordlandGoatStable_1_fence";
    IdAssetBundleBuildings["nordlandGoatStable_2"] = "nordlandGoatStable_2";
    IdAssetBundleBuildings["nordlandGoatStable_2_fence"] = "nordlandGoatStable_2_fence";
    IdAssetBundleBuildings["nordlandGoatStable_3"] = "nordlandGoatStable_3";
    IdAssetBundleBuildings["nordlandGoatStable_3_fence"] = "nordlandGoatStable_3_fence";
    IdAssetBundleBuildings["nordlandGoatStable_4"] = "nordlandGoatStable_4";
    IdAssetBundleBuildings["nordlandGoatStable_4_fence"] = "nordlandGoatStable_4_fence";
    IdAssetBundleBuildings["nordlandGoatStable_5"] = "nordlandGoatStable_5";
    IdAssetBundleBuildings["nordlandGoatStable_5_fence"] = "nordlandGoatStable_5_fence";
    IdAssetBundleBuildings["nordlandGoatStable_6"] = "nordlandGoatStable_6";
    IdAssetBundleBuildings["nordlandGoatStable_6_fence"] = "nordlandGoatStable_6_fence";
    IdAssetBundleBuildings["nordlandGoatStable_7"] = "nordlandGoatStable_7";
    IdAssetBundleBuildings["nordlandGoatStable_7_fence"] = "nordlandGoatStable_7_fence";
    IdAssetBundleBuildings["nordlandGoatStable_8"] = "nordlandGoatStable_8";
    IdAssetBundleBuildings["nordlandGoatStable_8_fence"] = "nordlandGoatStable_8_fence";
    IdAssetBundleBuildings["nordlandGoatStable_9"] = "nordlandGoatStable_9";
    IdAssetBundleBuildings["nordlandGoatStable_9_fence"] = "nordlandGoatStable_9_fence";
    IdAssetBundleBuildings["nordlandHouse_1"] = "nordlandHouse_1";
    IdAssetBundleBuildings["nordlandHouse_2"] = "nordlandHouse_2";
    IdAssetBundleBuildings["nordlandHouse_3"] = "nordlandHouse_3";
    IdAssetBundleBuildings["nordlandHouse_4"] = "nordlandHouse_4";
    IdAssetBundleBuildings["nordlandHouse_5"] = "nordlandHouse_5";
    IdAssetBundleBuildings["oasisPool_1"] = "oasisPool_1";
    IdAssetBundleBuildings["oasisPool_2"] = "oasisPool_2";
    IdAssetBundleBuildings["oasisPool_3"] = "oasisPool_3";
    IdAssetBundleBuildings["oasisPool_4"] = "oasisPool_4";
    IdAssetBundleBuildings["oasisPool_5"] = "oasisPool_5";
    IdAssetBundleBuildings["oasisPool_6"] = "oasisPool_6";
    IdAssetBundleBuildings["oasisPool_7"] = "oasisPool_7";
    IdAssetBundleBuildings["ornamentalTree_1"] = "ornamentalTree_1";
    IdAssetBundleBuildings["pavilion_1"] = "pavilion_1";
    IdAssetBundleBuildings["peachOrchard_1"] = "peachOrchard_1";
    IdAssetBundleBuildings["peachOrchard_2"] = "peachOrchard_2";
    IdAssetBundleBuildings["peachOrchard_3"] = "peachOrchard_3";
    IdAssetBundleBuildings["peachOrchard_4"] = "peachOrchard_4";
    IdAssetBundleBuildings["peachOrchard_5"] = "peachOrchard_5";
    IdAssetBundleBuildings["peachOrchard_6"] = "peachOrchard_6";
    IdAssetBundleBuildings["peachOrchard_7"] = "peachOrchard_7";
    IdAssetBundleBuildings["peachOrchard_8"] = "peachOrchard_8";
    IdAssetBundleBuildings["peachOrchard_blosssom_1"] = "peachOrchard_blosssom_1";
    IdAssetBundleBuildings["peachOrchard_peach_1"] = "peachOrchard_peach_1";
    IdAssetBundleBuildings["picnicTable_1"] = "picnicTable_1";
    IdAssetBundleBuildings["pigCup_1"] = "pigCup_1";
    IdAssetBundleBuildings["pigPen_1"] = "pigPen_1";
    IdAssetBundleBuildings["pigPen_1_fence"] = "pigPen_1_fence";
    IdAssetBundleBuildings["pigPen_2"] = "pigPen_2";
    IdAssetBundleBuildings["pigPen_2_fence"] = "pigPen_2_fence";
    IdAssetBundleBuildings["pigPen_3"] = "pigPen_3";
    IdAssetBundleBuildings["pigPen_3_fence"] = "pigPen_3_fence";
    IdAssetBundleBuildings["pigPen_4"] = "pigPen_4";
    IdAssetBundleBuildings["pigPen_4_fence"] = "pigPen_4_fence";
    IdAssetBundleBuildings["pigPen_5"] = "pigPen_5";
    IdAssetBundleBuildings["pigPen_5_fence"] = "pigPen_5_fence";
    IdAssetBundleBuildings["pigPen_6"] = "pigPen_6";
    IdAssetBundleBuildings["pigPen_6_fence"] = "pigPen_6_fence";
    IdAssetBundleBuildings["pigPen_7"] = "pigPen_7";
    IdAssetBundleBuildings["pigPen_7_fence"] = "pigPen_7_fence";
    IdAssetBundleBuildings["pigPen_8"] = "pigPen_8";
    IdAssetBundleBuildings["pigPen_8_fence"] = "pigPen_8_fence";
    IdAssetBundleBuildings["pigPen_9"] = "pigPen_9";
    IdAssetBundleBuildings["pigPen_9_fence"] = "pigPen_9_fence";
    IdAssetBundleBuildings["pileOfGoods_1"] = "pileOfGoods_1";
    IdAssetBundleBuildings["romanticTent_1"] = "romanticTent_1";
    IdAssetBundleBuildings["rushingWaterfall_1"] = "rushingWaterfall_1";
    IdAssetBundleBuildings["rushingWaterfall_2"] = "rushingWaterfall_2";
    IdAssetBundleBuildings["rushingWaterfall_3"] = "rushingWaterfall_3";
    IdAssetBundleBuildings["rushingWaterfall_4"] = "rushingWaterfall_4";
    IdAssetBundleBuildings["rushingWaterfall_5"] = "rushingWaterfall_5";
    IdAssetBundleBuildings["rushingWaterfall_6"] = "rushingWaterfall_6";
    IdAssetBundleBuildings["rushingWaterfall_7"] = "rushingWaterfall_7";
    IdAssetBundleBuildings["santasPostbox_1"] = "santasPostbox_1";
    IdAssetBundleBuildings["santasSleigh_1"] = "santasSleigh_1";
    IdAssetBundleBuildings["seesaw_1"] = "seesaw_1";
    IdAssetBundleBuildings["sheepPen_1"] = "sheepPen_1";
    IdAssetBundleBuildings["sheepPen_1_fence"] = "sheepPen_1_fence";
    IdAssetBundleBuildings["sheepPen_2"] = "sheepPen_2";
    IdAssetBundleBuildings["sheepPen_2_fence"] = "sheepPen_2_fence";
    IdAssetBundleBuildings["sheepPen_3"] = "sheepPen_3";
    IdAssetBundleBuildings["sheepPen_3_fence"] = "sheepPen_3_fence";
    IdAssetBundleBuildings["sheepPen_4"] = "sheepPen_4";
    IdAssetBundleBuildings["sheepPen_4_fence"] = "sheepPen_4_fence";
    IdAssetBundleBuildings["sheepPen_5"] = "sheepPen_5";
    IdAssetBundleBuildings["sheepPen_5_fence"] = "sheepPen_5_fence";
    IdAssetBundleBuildings["sheepPen_6"] = "sheepPen_6";
    IdAssetBundleBuildings["sheepPen_6_fence"] = "sheepPen_6_fence";
    IdAssetBundleBuildings["sheepPen_7"] = "sheepPen_7";
    IdAssetBundleBuildings["sheepPen_7_fence"] = "sheepPen_7_fence";
    IdAssetBundleBuildings["signEmpty"] = "signEmpty";
    IdAssetBundleBuildings["silentLamb_1"] = "silentLamb_1";
    IdAssetBundleBuildings["silo_1"] = "silo_1";
    IdAssetBundleBuildings["silo_2"] = "silo_2";
    IdAssetBundleBuildings["silo_3"] = "silo_3";
    IdAssetBundleBuildings["silo_4"] = "silo_4";
    IdAssetBundleBuildings["silo_5"] = "silo_5";
    IdAssetBundleBuildings["silo_6"] = "silo_6";
    IdAssetBundleBuildings["simpleHouse_1"] = "simpleHouse_1";
    IdAssetBundleBuildings["simpleHouse_2"] = "simpleHouse_2";
    IdAssetBundleBuildings["simpleHouse_3"] = "simpleHouse_3";
    IdAssetBundleBuildings["simpleHouse_4"] = "simpleHouse_4";
    IdAssetBundleBuildings["simpleHouse_5"] = "simpleHouse_5";
    IdAssetBundleBuildings["simpleHouse_6"] = "simpleHouse_6";
    IdAssetBundleBuildings["sleighWithGifts_1"] = "sleighWithGifts_1";
    IdAssetBundleBuildings["spookyWell_1"] = "spookyWell_1";
    IdAssetBundleBuildings["springFountain_1"] = "springFountain_1";
    IdAssetBundleBuildings["starSphere1_1"] = "starSphere1_1";
    IdAssetBundleBuildings["starSphere2_1"] = "starSphere2_1";
    IdAssetBundleBuildings["starSphere3_1"] = "starSphere3_1";
    IdAssetBundleBuildings["starSphere4_1"] = "starSphere4_1";
    IdAssetBundleBuildings["starSphere5_1"] = "starSphere5_1";
    IdAssetBundleBuildings["starSphere6_1"] = "starSphere6_1";
    IdAssetBundleBuildings["thicket_1"] = "thicket_1";
    IdAssetBundleBuildings["tiki1_1"] = "tiki1_1";
    IdAssetBundleBuildings["tiki2_1"] = "tiki2_1";
    IdAssetBundleBuildings["tiki3_1"] = "tiki3_1";
    IdAssetBundleBuildings["tiki4_1"] = "tiki4_1";
    IdAssetBundleBuildings["tiki5_1"] = "tiki5_1";
    IdAssetBundleBuildings["tiki6_1"] = "tiki6_1";
    IdAssetBundleBuildings["tiki7_1"] = "tiki7_1";
    IdAssetBundleBuildings["treeHouse_1"] = "treeHouse_1";
    IdAssetBundleBuildings["treeNursery_1"] = "treeNursery_1";
    IdAssetBundleBuildings["treeNursery_10"] = "treeNursery_10";
    IdAssetBundleBuildings["treeNursery_2"] = "treeNursery_2";
    IdAssetBundleBuildings["treeNursery_3"] = "treeNursery_3";
    IdAssetBundleBuildings["treeNursery_4"] = "treeNursery_4";
    IdAssetBundleBuildings["treeNursery_5"] = "treeNursery_5";
    IdAssetBundleBuildings["treeNursery_6"] = "treeNursery_6";
    IdAssetBundleBuildings["treeNursery_7"] = "treeNursery_7";
    IdAssetBundleBuildings["treeNursery_8"] = "treeNursery_8";
    IdAssetBundleBuildings["treeNursery_9"] = "treeNursery_9";
    IdAssetBundleBuildings["treeOfLanterns_1"] = "treeOfLanterns_1";
    IdAssetBundleBuildings["tropicalChickenCoop_1"] = "tropicalChickenCoop_1";
    IdAssetBundleBuildings["tropicalChickenCoop_2"] = "tropicalChickenCoop_2";
    IdAssetBundleBuildings["tropicalChickenCoop_3"] = "tropicalChickenCoop_3";
    IdAssetBundleBuildings["tropicalChickenCoop_4"] = "tropicalChickenCoop_4";
    IdAssetBundleBuildings["tropicalChickenCoop_5"] = "tropicalChickenCoop_5";
    IdAssetBundleBuildings["tropicalChickenCoop_6"] = "tropicalChickenCoop_6";
    IdAssetBundleBuildings["tropicalChickenCoop_7"] = "tropicalChickenCoop_7";
    IdAssetBundleBuildings["tropicalChickenCoop_8"] = "tropicalChickenCoop_8";
    IdAssetBundleBuildings["tropicalChickenCoop_fence1"] = "tropicalChickenCoop_fence1";
    IdAssetBundleBuildings["tropicalChickenCoop_fence2"] = "tropicalChickenCoop_fence2";
    IdAssetBundleBuildings["tropicalChickenCoop_fence3"] = "tropicalChickenCoop_fence3";
    IdAssetBundleBuildings["tropicalChickenCoop_fence4"] = "tropicalChickenCoop_fence4";
    IdAssetBundleBuildings["tropicalChickenCoop_fence5"] = "tropicalChickenCoop_fence5";
    IdAssetBundleBuildings["tropicalChickenCoop_fence6"] = "tropicalChickenCoop_fence6";
    IdAssetBundleBuildings["tropicalChickenCoop_fence7"] = "tropicalChickenCoop_fence7";
    IdAssetBundleBuildings["tropicalChickenCoop_fence8"] = "tropicalChickenCoop_fence8";
    IdAssetBundleBuildings["tropicalCowBarn_1"] = "tropicalCowBarn_1";
    IdAssetBundleBuildings["tropicalCowBarn_2"] = "tropicalCowBarn_2 ";
    IdAssetBundleBuildings["tropicalCowBarn_3"] = "tropicalCowBarn_3";
    IdAssetBundleBuildings["tropicalCowBarn_4"] = "tropicalCowBarn_4";
    IdAssetBundleBuildings["tropicalCowBarn_5"] = "tropicalCowBarn_5";
    IdAssetBundleBuildings["tropicalCowBarn_6"] = "tropicalCowBarn_6";
    IdAssetBundleBuildings["tropicalCowBarn_7"] = "tropicalCowBarn_7";
    IdAssetBundleBuildings["tropicalCowBarn_8"] = "tropicalCowBarn_8";
    IdAssetBundleBuildings["tropicalHouse_1"] = "tropicalHouse_1";
    IdAssetBundleBuildings["tropicalHouse_2"] = "tropicalHouse_2";
    IdAssetBundleBuildings["tropicalHouse_3"] = "tropicalHouse_3";
    IdAssetBundleBuildings["tropicalHouse_4"] = "tropicalHouse_4";
    IdAssetBundleBuildings["tropicalHouse_5"] = "tropicalHouse_5";
    IdAssetBundleBuildings["tropicalHouse_6"] = "tropicalHouse_6";
    IdAssetBundleBuildings["tropicalPigPen_1"] = "tropicalPigPen_1";
    IdAssetBundleBuildings["tropicalPigPen_2"] = "tropicalPigPen_2";
    IdAssetBundleBuildings["tropicalPigPen_3"] = "tropicalPigPen_3";
    IdAssetBundleBuildings["tropicalPigPen_4"] = "tropicalPigPen_4";
    IdAssetBundleBuildings["tropicalPigPen_5"] = "tropicalPigPen_5";
    IdAssetBundleBuildings["tropicalPigPen_6"] = "tropicalPigPen_6";
    IdAssetBundleBuildings["tropicalPigPen_7"] = "tropicalPigPen_7";
    IdAssetBundleBuildings["tropicalPigPen_8"] = "tropicalPigPen_8";
    IdAssetBundleBuildings["tropicalPigPen_9"] = "tropicalPigPen_9";
    IdAssetBundleBuildings["tropicalPigPen_fence1"] = "tropicalPigPen_fence1";
    IdAssetBundleBuildings["tropicalPigPen_fence2"] = "tropicalPigPen_fence2";
    IdAssetBundleBuildings["tropicalPigPen_fence3"] = "tropicalPigPen_fence3";
    IdAssetBundleBuildings["tropicalPigPen_fence4"] = "tropicalPigPen_fence4";
    IdAssetBundleBuildings["tropicalPigPen_fence5"] = "tropicalPigPen_fence5";
    IdAssetBundleBuildings["tropicalPigPen_fence6"] = "tropicalPigPen_fence6";
    IdAssetBundleBuildings["tropicalPigPen_fence7"] = "tropicalPigPen_fence7";
    IdAssetBundleBuildings["tropicalPigPen_fence8"] = "tropicalPigPen_fence8";
    IdAssetBundleBuildings["tropicalPigPen_fence9"] = "tropicalPigPen_fence9";
    IdAssetBundleBuildings["twinklingSnowman_1"] = "twinklingSnowman_1";
    IdAssetBundleBuildings["unicornStatue_1"] = "unicornStatue_1";
    IdAssetBundleBuildings["uniqueWindmill_1"] = "uniqueWindmill_1";
    IdAssetBundleBuildings["upgradableStarSphere_1"] = "upgradableStarSphere_1";
    IdAssetBundleBuildings["upgradableStarSphere_2"] = "upgradableStarSphere_2";
    IdAssetBundleBuildings["upgradableStarSphere_3"] = "upgradableStarSphere_3";
    IdAssetBundleBuildings["upgradableStarSphere_4"] = "upgradableStarSphere_4";
    IdAssetBundleBuildings["upgradableStarSphere_5"] = "upgradableStarSphere_5";
    IdAssetBundleBuildings["upgradableStarSphere_6"] = "upgradableStarSphere_6";
    IdAssetBundleBuildings["vegetablePatch_1"] = "vegetablePatch_1";
    IdAssetBundleBuildings["weddingPavilion_1"] = "weddingPavilion_1";
    IdAssetBundleBuildings["weddingPavilion_2"] = "weddingPavilion_2";
    IdAssetBundleBuildings["weddingPavilion_3"] = "weddingPavilion_3";
    IdAssetBundleBuildings["weddingPavilion_4"] = "weddingPavilion_4";
    IdAssetBundleBuildings["weddingPavilion_5"] = "weddingPavilion_5";
    IdAssetBundleBuildings["weddingPavilion_6"] = "weddingPavilion_6";
    IdAssetBundleBuildings["weddingPavilion_7"] = "weddingPavilion_7";
    IdAssetBundleBuildings["well_1"] = "well_1";
    IdAssetBundleBuildings["wellspringOfCharity_1"] = "wellspringOfCharity_1";
    IdAssetBundleBuildings["wellspringOfCharity_2"] = "wellspringOfCharity_2";
    IdAssetBundleBuildings["wellspringOfCharity_3"] = "wellspringOfCharity_3";
    IdAssetBundleBuildings["westernWindmill_1"] = "westernWindmill_1";
    IdAssetBundleBuildings["windmill_2"] = "windmill_2";
    IdAssetBundleBuildings["windmill_3"] = "windmill_3";
    IdAssetBundleBuildings["windmill_4"] = "windmill_4";
    IdAssetBundleBuildings["windmill_5"] = "windmill_5";
    IdAssetBundleBuildings["windmill_6"] = "windmill_6";
    IdAssetBundleBuildings["windmill_7"] = "windmill_7";
    IdAssetBundleBuildings["windmill_blades_2"] = "windmill_blades_2";
    IdAssetBundleBuildings["windmill_blades_3"] = "windmill_blades_3";
    IdAssetBundleBuildings["windmill_blades_4"] = "windmill_blades_4";
    IdAssetBundleBuildings["windmill_blades_5"] = "windmill_blades_5";
    IdAssetBundleBuildings["windmill_blades_6"] = "windmill_blades_6";
    IdAssetBundleBuildings["windmill_blades_7"] = "windmill_blades_7";
    IdAssetBundleBuildings["winterWonder_1"] = "winterWonder_1";
    IdAssetBundleBuildings["winterWonder_2"] = "winterWonder_2";
    IdAssetBundleBuildings["winterWonder_3"] = "winterWonder_3";
    IdAssetBundleBuildings["winterWonder_4"] = "winterWonder_4";
    IdAssetBundleBuildings["winterWonder_5"] = "winterWonder_5";
    IdAssetBundleBuildings["winterWonder_6"] = "winterWonder_6";
    IdAssetBundleBuildings["winterWonder_7"] = "winterWonder_7";
})(IdAssetBundleBuildings || (IdAssetBundleBuildings = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/IdAssetBundleBuildings.ts
// module id = 573
// module chunks = 3